import React, { PureComponent } from 'react';
import style from './GuideLink.scss';
import { withRouter } from 'react-router-dom';
import classnames from 'classnames';
import { ActiveLink } from '../../ActiveLink';
import { toUrlFormat } from '../../../../utils/treeVisitors';
import ArticleSmall from 'wix-ui-icons-common/ArticleSmall';
import { NAV_TYPES } from '../../../LoggerFactory/BiAnalyticsLogger/events/consts';
import { CustomLink } from '../../PageElements/CustomLink';
import { Text } from 'wix-style-react';
import { connectStore } from '../../../appContext/StoreProvider/ConnectStore';
import { ChangelogBadge } from '../../NavigationMenu/TreeSectionTitle/ChangelogPimple';
import { ExternalMenuLink } from './ExternalMenuLink';
import { getShouldShowPimple } from '../../NavigationMenu/utils';

class GuideLink extends PureComponent {
  isTopLevel = () => {
    return this.props.treeDepth === 0;
  };

  getName = () => {
    const { displayName, name } = this.props;
    return displayName || name;
  };

  getUrlFormat = () => {
    if (this.props.prefix) {
      return `${this.props.prefix}/${toUrlFormat(this.getName())}`;
    }
    return toUrlFormat(this.getName());
  };

  activeLinkComparator = (currentlyActive, compareTo) => {
    return currentlyActive === compareTo;
  };

  render() {
    const { url, isExternalLink, isChangelog, link, content } = this.props;
    if (isExternalLink) {
      return (
        <ExternalMenuLink
          title={this.getName()}
          url={url}
          isTopLevel={this.isTopLevel()}
        />
      );
    }
    return (
      <ActiveLink>
        {({ isActive }) => {
          const isLinkActive = isActive(link, this.activeLinkComparator);

          const shouldShowPimple = getShouldShowPimple(
            this.props.store,
            isChangelog,
            content,
            link,
            isLinkActive,
          );

          return (
            <CustomLink
              className={classnames({
                [style.guideLink]: true,
                [style.topLevel]: this.isTopLevel(),
                [style.highlight]: isActive(`/${this.getUrlFormat()}`),
              })}
              to={{
                pathname: `/${this.getUrlFormat()}`,
                state: { navType: NAV_TYPES.MENU_ARTICLE },
              }}
            >
              <React.Fragment>
                <span className={style.articleIcon}>
                  <ArticleSmall />
                </span>
                <Text
                  className={style.nameContainer}
                  ellipsis
                  size="small"
                  weight="normal"
                  secondary
                  placement="right"
                >
                  {this.getName()}
                </Text>
              </React.Fragment>
              {shouldShowPimple && <ChangelogBadge />}
            </CustomLink>
          );
        }}
      </ActiveLink>
    );
  }
}
export default connectStore(withRouter(GuideLink));
